import { ErrorMessageContents } from '../../helpers/hub'
import { SecuritySearchResult } from './types'

export const searchSecurities = (
  gridIndex: number,
  query: string,
  ignoreWatchlist: boolean
) =>
  ({
    type: 'searchSecurities.searchSecurities',
    payload: { gridIndex, query, ignoreWatchlist }
  } as const)
export type SearchSecuritiesAction = ReturnType<typeof searchSecurities>

export const searchSecuritiesSuccess = (
  gridIndex: number,
  securities: SecuritySearchResult[],
  ignoreWatchlist: boolean
) =>
  ({
    type: 'searchSecurities.searchSecuritiesSuccess',
    payload: { gridIndex, securities, ignoreWatchlist }
  } as const)
export type SearchSecuritiesSuccessAction = ReturnType<
  typeof searchSecuritiesSuccess
>

export const searchSecuritiesFailure = (
  gridIndex: number,
  error: ErrorMessageContents
) =>
  ({
    type: 'searchSecurities.searchSecuritiesFailure',
    error: true,
    payload: { gridIndex, error }
  } as const)
export type SearchSecuritiesFailureAction = ReturnType<
  typeof searchSecuritiesFailure
>

export const selectFirstIssuerResult = (gridIndex: number) =>
  ({
    type: 'searchSecurities.selectFirstIssuerResult',
    payload: { gridIndex }
  } as const)
export type SelectFirstIssuerResultAction = ReturnType<
  typeof selectFirstIssuerResult
>

export const globalSearch = (query: string) =>
  ({ type: 'searchSecurities.globalSearch', payload: query } as const)
export type GlobalSearchAction = ReturnType<typeof globalSearch>

export const globalSearchSuccess = (searchResults: SecuritySearchResult[]) =>
  ({
    type: 'searchSecurities.globalSearchSuccess',
    payload: { searchResults }
  } as const)
export type GlobalSearchSuccessAction = ReturnType<typeof globalSearchSuccess>

export const clearGlobalSearch = () =>
  ({ type: 'searchSecurities.clearGlobalSearch' } as const)
export type ClearGlobalSearchAction = ReturnType<typeof clearGlobalSearch>

export type SearchSecuritiesActions =
  | SearchSecuritiesAction
  | SearchSecuritiesSuccessAction
  | SearchSecuritiesFailureAction
  | SelectFirstIssuerResultAction
  | GlobalSearchAction
  | GlobalSearchSuccessAction
  | ClearGlobalSearchAction
